import dayjs from 'dayjs';

/** Calendar days between today and the block's next charge, in the device's timezone — negative
 * once that date passed unpaid. Null when the block has no date, so the event omits the property. */
export const getDaysToPaymentDate = (paymentDate: string): number | null => {
  const parsed = dayjs(paymentDate);
  if (!parsed.isValid()) return null;

  return parsed.startOf('day').diff(dayjs().startOf('day'), 'day');
};
